import React from 'react'

export default function Header() {
  return (
    <>
    <div>
    <div className="p-4 p-md-5 mb-4 text-white rounded bg-success">
    <div className="col-md-6 px-0">
      <h1 className="display-4 fst-italic">The Easiest Way to Get Your Dream Job.</h1>
      <p className="lead my-3" style={{color:'blanchedalmond'}}>Start Building Your Own Carrer, Find the Most Exciting Startup Jobs</p>
    </div>
  </div>
    </div>
    </>
  )
}
